import ProjectGroupList from './project_group_list'

export default ProjectGroupList
